import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { BenefitsenrollmentstatusDetail } from './BenefitsenrollmentstatusDetails';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class BenefitsenrollmentstatusComponentService {
    private _payhistoryServiceReportUrl = CONFIGURATION.baseServiceUrl + 'benifitenrollmentstatusservice/';
    private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';
    constructor(private _http: Http) { }

    getReportData(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._payhistoryServiceReportUrl + 'getbenifitreportreferencedata', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getBenfitReports(filterCriteria: any): Observable<BenefitsenrollmentstatusDetail[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._payhistoryServiceReportUrl + 'v2/getreferencedata', filterCriteria, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getSSnData(ssnData: any): Observable<BenefitsenrollmentstatusDetail[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
            + '&TaxYear=' + ssnData.taxyear
            + '&ControlGroup=' + ssnData.controlgroup
            + '&ReportName=' + 'BenefitsEnrollmentStatus';
        return this._http.get(this._ssnUrl + fileName, { headers: headers })
            .map((response: Response) => <BenefitsenrollmentstatusDetail[]>response.json())
            .catch(this.handleError);
    }

    downloadExcelReport(filterCriteria: any): any {
        const fileName = 'excel-download?TaxYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup;
        const url = this._payhistoryServiceReportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }
    searchData(year: any, cg: any, searchValue: any) {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        const fileName = {
            "taxYear": year,
            "controlGroup": cg,
            "searchKey": searchValue,
            "pagination": {
                "pageNo": "",
                "pageSize": "10"
            }
        }
        return this._http.post(this._payhistoryServiceReportUrl + 'v2/getreferencedata', fileName, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getData(year: any, cg: any, currenpage: any) {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        const fileName = {
            "taxYear": year,
            "controlGroup": cg,
            "searchKey": "",
            "pagination": {
                "pageNo": currenpage,
                "pageSize": "10"
            }
        }
        return this._http.post(this._payhistoryServiceReportUrl + 'v2/getreferencedata', fileName, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }
}



// WEBPACK FOOTER //
// ./src/app/benefitsenrollmentstatus/benefitsenrollmentstatus.service.ts